import { render, staticRenderFns } from "./Visionboard.vue?vue&type=template&id=1caccae5&"
import script from "./Visionboard.vue?vue&type=script&lang=js&"
export * from "./Visionboard.vue?vue&type=script&lang=js&"
import style0 from "./Visionboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports